<template lang="html">
    <div>
        <!-- Top area -->
        <top-area :integration="currentIntegration" >
            <div class="bg-blue-pale p-2 mt-3">
                Please note that you need to have active products on GYG in order to connect with Pluralo. Log into your <a class="darkest underlined" href="https://supplier.getyourguide.com/" target="_blank">Supply Portal</a>.  Don’t have an account? <a class="darkest underlined" href="https://supplier.getyourguide.com/en/register" target="_blank">Sign Up here</a>.
            </div>
        </top-area>

        <!-- Lower area -->
        <div class="px-5 pt-4 pb-4">
            <!-- Steps -->
            <div class="">
                <div class="d-flex stepRow">
                    <div class="stepNumber d-flex border-dark align-items-center justify-content-center">1</div>

                    <div class="stepText d-flex flex-grow-1">
                        Set your commissions and payment protocol with GetYourGuide.
                    </div>

                    <div class="stepButton d-flex">
                        <loader v-if="creatingProtocol"></loader>
                        <button v-else-if="!isIntegrated" type="button" class="btn tertiary w-100" @click="crateProtocol()">Create Protocol</button>
                        <button v-else-if="isIntegrated" type="button" class="btn tertiary w-100"><i class="fas fa-check color-3"></i> Created</button>
                    </div>
                </div>

                <div class="d-flex stepRow">
                    <div class="stepNumber d-flex border-dark align-items-center justify-content-center">2</div>

                    <div class="stepText d-flex flex-grow-1">
                        <div>
                            Log into your <a class="color-1 underlined bold" href="https://supplier.getyourguide.com/" target="_blank">Supply Portal</a> and using the table bellow connect the products ID.<br><b>Follow the GYG instructions guide to finish the connection on their site</b>.
                        </div>
                    </div>

                    <div class="stepButton d-flex">
                        <button type="button" class="btn tertiary w-100" @click="clickInstructionsGuide">Instructions Guide</button>
                    </div>
                </div>

                <div class="d-flex stepRow justify-content-between" v-if="isIntegrated">
                    <button type="button" class="btn action" @click="deactivateIntegration()" :disabled="isDeactivating" >Disable Integration</button>
                    <button type="button" class="btn blue" @click="openAgentDetails()">Open GYG Agent Details</button>
                </div>
            </div>

            <!-- Product list holder -->
            <div class="productListHolder">
                <!-- Product list -->
                <list class="mt-4" :header="productListHeader" :body="productListBody" :rows="products" ></list>
            </div>

            <!-- Bottom buttons -->
            <div class="d-flex mt-4">
                <button type="button" name="button" class="btn wide tertiary flex-grow-1 mr-2" @click="closeModal">Cancel</button>
                <button type="button" name="button" :disabled="!isIntegrated" class="btn wide primary flex-grow-1 ml-2"@click="closeModal">Done, I’m connected</button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import List from '@/tools/list/baseList'
import Loader from '@/tools/loaders/loader1'
import topArea from '@/components/integrations/integratePopup/popupParts/topArea'

export default {
    data: function () {
        return {
            creatingProtocol: false,
            isDeactivating: false,
        }
    },
    computed: {
        ...mapGetters([
            'getProducts',
            'getOTAs',
            'getAgents',
            'getSelectedIntegration',
        ]),
        currentIntegration: function () {
            return this.getSelectedIntegration;
        },
        gygOta: function () {
            return this.getOTAs.find(ota => ota.id == 1);
        },
        products: function () {
            return this.getProducts;
        },
        productListHeader: function() {
            return {
                selection: {
                    active: false,
                    event: (event) => {}
                },
                list: {
                    id: 'ID',
                    name: 'Product Name',
                },
            };
        },
        productListBody: function () {
            return {
                selection: {
                    active: false,
                    event: (event) => {}
                },
                customCells: {
                    id: this.formatId,
                    name: this.formatName,
                },
                customRowEvent: null,
            }
        },
        isIntegrated: function () {
            return typeof this.getAgents.find(agent => {
                return agent.isOTA && agent.channelType == 202 && agent.protocolStatus == 1;
            }) == "object"
        }
    },
    methods: {
        ...mapActions([
            'closeModal',
            'connectToGetYourGuide',
            'setSelectedPerson',
            'openModal',
            'openComponentModal',
            'openIntegrationSettings',
            'requestDeactivateGYG'
        ]),
        openAgentDetails: function () {
            this.openIntegrationSettings(this.currentIntegration);
        },
        formatId: function(item) {
            return item.externalBookingSystemCode;
        },
        formatName: function(item) {
            return '<div class="bold">' + item.name + '</div>';
        },
        clickInstructionsGuide: function () {
            window.open(this.gygOta.integration.helpLink);
        },
        crateProtocol: function () {
            this.creatingProtocol = true
            this.connectToGetYourGuide().then(response => {
                this.creatingProtocol = false;

                if(response && response.status == 200){
                    this.setSelectedPerson(response.data);

                    // set modal AgentView selected tab:
                    const currentTime = new Date().getTime();
                    const expires = new Date(currentTime + 15 * 60000);
                    const value = '#commissions';
                    localStorage.setItem(`vue-tabs-component-pluralo.cache.${window.location.host}${window.location.pathname}`, JSON.stringify({ value, expires }));

                    this.openModal({
                        name: 'AgentView',
                        callback: () => {
                            setTimeout(() => {
                                this.openComponentModal(this.gygOta.howToConnect);
                            }, 10);
                        }
                    });
                }
            }).catch(err => {
                this.creatingProtocol = false;
            })
        },
        deactivateIntegration: function () {
            this.$dialog.confirm(
                '<h1 class="text-center mb-4">Disable integration?</h1>',
                {
                    okText: 'Yes',
                    customClass: 'red'
                }
            ).then(() => {
                this.isDeactivating = true
                this.requestDeactivateGYG().then(response => {
                    this.isDeactivating = false
                    this.closeModal()
                }).catch(err => {
                    this.isDeactivating = false
                    this.closeModal()
                })
            })
            .catch(function () {
            });
        }
    },
    components:{
        topArea,
        List,
        Loader
    }
}
</script>

<style lang="scss" scoped>
    .stepRow {
        margin-bottom: 2em;

        .stepNumber {
            font-size: 16px;
            border-radius: 9999px;
            width: 30px;
            max-width: 30px;
            min-width: 30px;
            text-align: center;
            height: 30px;
            padding-top: 1px;
            font-weight: bold;
            margin-right: 1em;
        }

        .stepButton {
            white-space: nowrap;
            width: 150px;
        }
    }
</style>



// WEBPACK FOOTER //
// howToConnect.vue?f86d0a9a